// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"fb39b215","562":"82450913"}[chunkId] + ".chunk.css";
};